import type { QueryClient } from "@tanstack/react-query";

import type { MeResponse, SubscriptionStatus } from "../types";

interface AuthoritativeSubscriptionState {
  shop_id: string;
  active: boolean;
  plan_code: string | null;
  status: SubscriptionStatus | null;
  trial_ends_at?: string | null;
}

/**
 * Publish a billing mutation/sync result into the single authoritative `me`
 * row immediately. The entitlement-generation boundary hides descendants and
 * purges plan-sensitive caches before accepting this new visibility scope.
 */
export function applyAuthoritativeSubscription(
  queryClient: QueryClient,
  authority: AuthoritativeSubscriptionState,
): void {
  queryClient.setQueryData<MeResponse>(["me"], (current) => {
    if (current === undefined || current.shop_id !== authority.shop_id) {
      return current;
    }
    return {
      ...current,
      subscription: {
        active: authority.active,
        plan_code: authority.active ? authority.plan_code : null,
        status: authority.status,
        trial_ends_at:
          authority.trial_ends_at === undefined
            ? current.subscription.trial_ends_at
            : authority.trial_ends_at,
      },
    };
  });
}
